// extracted by mini-css-extract-plugin
export default {"logo":"FooterText_logo__qPl19","forceShow":"FooterText_forceShow__GrDob"};